// extracted by mini-css-extract-plugin
export default {"page":"About_page__1X-r6","wrap":"About_wrap__EMvrj","copy":"About_copy__VMskS","quoteCard":"About_quoteCard__J0ydk","quoteMark":"About_quoteMark__Cj0sS"};